import { FC } from "react";
import { TagsProps } from "./types";
import { Column, Row } from "../../containers";
import { AlignItems, Wrap } from "../../containers/types";
import Tag from "../Tag";
import { Heading } from "../../typography";
import { useThemeStore } from "../../../stores";

const Tags: FC<TagsProps> = ({
  children,
  props,
  color,
  className = "",
  style = {},
}) => {
  const theme = useThemeStore((state) => state.theme);
  return (
    <Column
      gap={10}
      className={className}
      style={{ width: "100%", ...style }}
      {...props}
      alignItems={AlignItems.Start}
    >
      <Heading size={16} color={color || theme.textOnOverlay}>
        تگ ها
      </Heading>
      <Row flexWrap={Wrap.Wrap} gap={10} style={{ width: "100%" }}>
        {children?.map((tag, idx) => (
          <Tag key={idx}>{tag}</Tag>
        ))}
      </Row>
    </Column>
  );
};

export default Tags;
